module.exports = __webpack_public_path__ + "img/hourglass_icon.18f1bdd8.png";